module.exports = __webpack_public_path__ + "img/img4.9c843ea5.png";